import { Button } from '@/components/ui/button';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import { Input } from '@/components/ui/input';
import { PlusCircle } from 'lucide-react';
import { cn } from '@/lib/utils';
import { Badge } from '@/components/ui/badge';
import { Separator } from '@/components/ui/separator';

type DataTableDateFilterProps = {
    title: string;
    value: string;
    onChange: (value: string) => void;
};

export function DataTableDateFilter({ title, value, onChange }: DataTableDateFilterProps) {
    const isActive = value !== '';

    return (
        <Popover>
            <PopoverTrigger asChild>
                <Button
                    variant="outline"
                    size="sm"
                    className={cn('h-8 border-dashed bg-filter', isActive && 'bg-filter-active')}
                >
                    <PlusCircle className="size-3.5" />
                    {title}
                    {isActive && (
                        <>
                            <Separator orientation="vertical" className="mx-1 h-4" />
                            <Badge variant="secondary" className="rounded-sm px-1 font-normal">
                                {value}
                            </Badge>
                        </>
                    )}
                </Button>
            </PopoverTrigger>
            <PopoverContent className="w-[250px]" align="start">
                <Input type="date" value={value} onChange={(e) => onChange(e.target.value)} autoFocus />
                {isActive && (
                    <Button variant="ghost" size="sm" className="mt-2 w-full" onClick={() => onChange('')}>
                        Effacer
                    </Button>
                )}
            </PopoverContent>
        </Popover>
    );
}
